<template lang="pug">
  .dateRow.text-center.mt-2
    .dateRow__dataBox.badge-pill.d-inline-block
      small {{ moment(timeData) }}
</template>

<script>
const moment = require('moment');

export default {
  name: 'TitleDateComponent',
  props: {
    timeData: {
      type: String,
      required: true
    }
  },
  methods: {
    moment(time) {
      return moment(time).format('YYYY/MM/DD');
    }
  }
};
</script>

<style>

</style>
